import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/user-topic.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-times" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex mb-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
  src: _imports_0,
  alt: "user"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "text-base font-bold text-h-neutral-700" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs font-semibold text-h-neutral-700"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-h-primary-600 font-extrabold !text-[14px] cursor-pointer" }
const _hoisted_16 = { class: "relative after:content[' '] after:absolute after:top-0 after:left-0 after:cursor-pointer after:w-full after:h-full after:bg-transparent" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      group: _ctx.reply?.id,
      visible: _ctx.isReplyExpanded,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isReplyExpanded) = $event)),
      modal: "",
      showHeader: false,
      dismissableMask: "",
      class: "custom-dialogForum max-w-[90%] lg:max-w-[1113px] flex flex-col w-full mb-4 overflow-hidden"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["p-5 border-l-8 rounded-md custom-quill", `${_ctx.reply?.comment
        ? 'bg-h-primary-50 border border-h-primary-100'
        : 'bg-h-neutral-100 border border-h-neutral-200 text-h-neutral-700 font-normal	'
        }`])
        }, [
          _createElementVNode("button", {
            class: "absolute right-5 top-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalReply && _ctx.closeModalReply(...args)))
          }, _hoisted_3),
          _createElementVNode("header", _hoisted_4, [
            (!_ctx.reply?.authorComment?.photoProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : (_ctx.reply?.authorComment?.photoProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
                      src: _ctx.reply?.authorComment?.photoProfile.path,
                      alt: "user"
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.reply?.authorComment?.name + ":"), 1),
              (_ctx.reply?.created)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Publicado",
                  en: "Published",
                })) + " " + _toDisplayString(_ctx.timeSinceCreation), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.reply?.comment)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                innerHTML: _ctx.reply?.comment,
                class: "ql-editor text-sm text-h-neutral-700"
              }, null, 8, _hoisted_13))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createElementVNode("i", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Comentário excluído.",
                en: "Comment deleted.",
              })), 1)
              ]))
        ], 2)
      ]),
      _: 1
    }, 8, ["group", "visible"]),
    (_ctx.reply !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["relative flex flex-col w-full gap-2 p-3 mb-4 border-l-8 rounded cursor-pointer", `${_ctx.reply?.comment
      ? 'bg-h-primary-50 border border-h-primary-100'
      : 'bg-h-neutral-100 border border-h-neutral-200 text-h-neutral-700 font-normal	'
      }`]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.expandModalReply && _ctx.expandModalReply(...args)))
        }, [
          _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.reply?.authorComment?.name
            ? _ctx.reply?.authorComment?.name + ":"
            : _ctx.$t("forum.comment.authorDeleted") + ":"), 1),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.reply?.comment !== null)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  innerHTML: _ctx.reply?.comment,
                  class: "text-sm text-h-neutral-700 !whitespace-pre-wrap !truncate !line-clamp-3 md:!line-clamp-2 !inline-block !text-wrap ql-editor"
                }, null, 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Comentário excluído.",
                en: "Comment deleted.",
              })), 1)
                ]))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}